export const lg_header_pricing = {
  lg_header_pricing_th: {
    pr_badge: "แผนราคา",
    pr_title: "เลือกแผนที่เหมาะกับคุณ",
    pr_subtitle:
      "ราคาเรียบง่าย โปร่งใส สำหรับทุกขนาดทีม เริ่มฟรีและขยายตามการเติบโต",
    pr_most_popular: "ยอดนิยม",
    pr_month: "เดือน",
    pr_custom: "ราคาพิเศษ",
    pr_plan_free_name: "Free",
    pr_plan_free_desc: "สำหรับบุคคลหรือทดลองประชุมขนาดเล็ก",
    pr_plan_free_cta: "เริ่มฟรี",
    pr_plan_pro_name: "Pro",
    pr_plan_pro_desc: "สำหรับบุคคลและทีมขนาดเล็ก",
    pr_plan_pro_cta: "ทดลอง 14 วัน",
    pr_plan_business_name: "Business",
    pr_plan_business_desc: "สำหรับองค์กรที่ต้องการบันทึกและรายงานการโหวต",
    pr_plan_business_cta: "ทดลอง 14 วัน",
    pr_plan_enterprise_name: "Enterprise",
    pr_plan_enterprise_desc: "สำหรับองค์กรขนาดใหญ่ที่ต้องการการปรับแต่ง",
    pr_plan_enterprise_cta: "ติดต่อฝ่ายขาย",
    pr_feat_10pax: "ผู้เข้าร่วมสูงสุด 10 คน",
    pr_feat_40min: "40 นาทีต่อครั้ง",
    pr_feat_50pax: "ผู้เข้าร่วมสูงสุด 50 คน",
    pr_feat_100pax: "ผู้เข้าร่วมสูงสุด 100 คน",
    pr_feat_custom_pax: "กำหนดจำนวนผู้เข้าร่วมเอง",
    pr_feat_unlimited: "ไม่จำกัดเวลาการประชุม",
    pr_feat_screen: "แชร์หน้าจอ",
    pr_feat_chat: "แชทและแชร์ไฟล์",
    pr_feat_fair_usage: "รวม Fair Usage",
    pr_feat_no_record: "บันทึกการประชุม",
    pr_feat_no_vote: "รายงานการโหวต",
    pr_feat_no_minutes: "เสริมรายงานการประชุม (ตัวเลือก)",
    pr_feat_60rec: "บันทึก 60 นาที/เดือน",
    pr_feat_120rec: "บันทึก 120 นาที/เดือน",
    pr_feat_custom_rec: "กำหนดโควต้าบันทึกเอง",
    pr_feat_custom_usage: "กำหนดโควต้าการใช้งานเอง",
    pr_feat_rtmp: "สตรีมผ่าน RTMP",
    pr_feat_voting: "โหวตในการประชุม",
    pr_feat_vote_reports: "รายงานการโหวต",
    pr_feat_adv_vote_reports: "รายงานการโหวตขั้นสูง",
    pr_feat_legal_minutes: "บริการรายงานการประชุมทางกฎหมาย",
    pr_feat_opt_legal_minutes: "เสริมรายงานการประชุมทางกฎหมาย (ตัวเลือก)",
    pr_feat_priority: "ซัพพอร์ตลำดับความสำคัญสูง",
    pr_fair_title: "เกี่ยวกับ Fair Usage",
    pr_fair_desc:
      "แผนชำระเงินทุกแผนมีขีดจำกัด Fair Usage ที่เหมาะกับการใช้งานทางธุรกิจทั่วไป นาทีการใช้งานคำนวณจากจำนวนผู้เข้าร่วม × ระยะเวลาประชุม ตัวอย่างเช่น ประชุม 1 ชั่วโมง 10 คน ใช้ 600 นาทีการใช้งาน ส่วนใหญ่เพียงพอสำหรับการใช้งานประจำวัน",
    pr_storage_title: "พื้นที่จัดเก็บการบันทึก",
    pr_storage_desc:
      "การบันทึกการประชุมถูกจัดเก็บอย่างปลอดภัยในพื้นที่ที่ Dmeets ควบคุม การเข้าถึง ระยะเวลาเก็บ และการลบข้อมูล ถูกจัดการโดย Dmeets เพื่อให้เป็นไปตามมาตรฐานการคุ้มครองข้อมูล",
    pr_faq_title: "คำถามที่พบบ่อย",
    pr_faq_q1: "นาทีการใช้งานการประชุมคืออะไร?",
    pr_faq_a1:
      "นาทีการใช้งานคำนวณจากจำนวนผู้เข้าร่วมและระยะเวลาประชุม เช่น ประชุม 1 ชั่วโมง 10 คน ใช้ 600 นาที",
    pr_faq_q2: "แผนชำระเงินไม่จำกัดเวลาจริงหรือ?",
    pr_faq_a2:
      "แผนชำระเงินมีเวลาประชุมไม่จำกัด ภายใต้นโยบาย Fair Usage รายเดือน",
    pr_faq_q3: "ฉันทดลองใช้ Dmeets ฟรีได้ไหม?",
    pr_faq_a3:
      "ได้! แผน Free ใช้ได้ตลอด และแผน Pro กับ Business มีทดลองใช้ฟรี 14 วัน ไม่ต้องใช้บัตรเครดิต",
    pr_faq_q4: "การบันทึกจัดเก็บที่ไหน?",
    pr_faq_a4:
      "การบันทึกจัดเก็บในพื้นที่ที่ Dmeets ควบคุม โดย Dmeets จัดการการเข้าถึงและการลบข้อมูล",
    pr_faq_q5: "นาทีบันทึกที่ไม่ได้ใช้โอนได้ไหม?",
    pr_faq_a5:
      "ไม่ได้ โควต้าการบันทึกรีเซ็ตทุกเดือน และนาทีที่ไม่ได้ใช้จะไม่โอนไปเดือนถัดไป",
    pr_faq_q6: "ซื้อนาทีการใช้งานหรือบันทึกเพิ่มได้ไหม?",
    pr_faq_a6: "ได้ สามารถซื้อนาทีการใช้งานและบันทึกเพิ่มเติมได้เมื่อต้องการ",
    pr_faq_q7: "จะยกเลิกการสมัครสมาชิกได้อย่างไร?",
    pr_faq_a7:
      "ยกเลิกได้ทุกเมื่อผ่านการตั้งค่าบัญชี ไม่มีค่าปรับหรือค่าธรรมเนียมซ่อนเร้น",
    pr_cta_title: "พร้อมเริ่มต้นแล้วหรือยัง?",
    pr_cta_subtitle:
      "เริ่มด้วยแผนฟรี หรือทดลอง Pro/Business ฟรี 14 วัน ไม่ต้องใช้บัตรเครดิต",
    pr_cta_start: "เริ่มฟรีเลย",
    pr_cta_contact: "ติดต่อเรา",
  },
  lg_header_pricing_en: {
    pr_badge: "Pricing Plans",
    pr_title: "Choose Your Perfect Plan",
    pr_subtitle:
      "Simple, transparent pricing for teams of all sizes. Start free and scale as you grow.",
    pr_most_popular: "Most Popular",
    pr_month: "month",
    pr_custom: "Custom",
    pr_plan_free_name: "Free",
    pr_plan_free_desc: "For individuals or small trial meetings",
    pr_plan_free_cta: "Start Free",
    pr_plan_pro_name: "Pro",
    pr_plan_pro_desc: "For individuals and small teams",
    pr_plan_pro_cta: "Start 14-Day Trial",
    pr_plan_business_name: "Business",
    pr_plan_business_desc:
      "For organizations that need recordings and vote reports",
    pr_plan_business_cta: "Start 14-Day Trial",
    pr_plan_enterprise_name: "Enterprise",
    pr_plan_enterprise_desc: "For large organizations with custom needs",
    pr_plan_enterprise_cta: "Contact Sales",
    pr_feat_10pax: "Up to 10 participants",
    pr_feat_40min: "40 minutes per session",
    pr_feat_50pax: "Up to 50 participants",
    pr_feat_100pax: "Up to 100 participants",
    pr_feat_custom_pax: "Custom participant limit",
    pr_feat_unlimited: "Unlimited meeting duration",
    pr_feat_screen: "Screen sharing",
    pr_feat_chat: "Chat & file sharing",
    pr_feat_fair_usage: "Fair usage included",
    pr_feat_no_record: "Meeting recording",
    pr_feat_no_vote: "Vote reports",
    pr_feat_no_minutes: "Optional meeting minutes add-on",
    pr_feat_60rec: "60 recording minutes/month",
    pr_feat_120rec: "120 recording minutes/month",
    pr_feat_custom_rec: "Custom recording quota",
    pr_feat_custom_usage: "Custom usage quota",
    pr_feat_rtmp: "RTMP streaming available",
    pr_feat_voting: "In-meeting voting",
    pr_feat_vote_reports: "Vote reports",
    pr_feat_adv_vote_reports: "Advanced vote reports",
    pr_feat_legal_minutes: "Legal meeting minutes service",
    pr_feat_opt_legal_minutes: "Optional legal meeting minutes add-on",
    pr_feat_priority: "Priority support",
    pr_fair_title: "About Fair Usage",
    pr_fair_desc:
      "All paid plans include generous fair usage limits designed for typical business use. Meeting usage is calculated based on participant count × meeting duration. For example, a 1-hour meeting with 10 people uses 600 meeting usage minutes. Most teams find these limits more than sufficient for their daily needs.",
    pr_storage_title: "Recording Storage",
    pr_storage_desc:
      "Meeting recordings are stored securely in Dmeets-controlled storage. Access, retention periods, and deletion are managed by Dmeets to ensure compliance with data protection standards and provide you with reliable, secure access to your meeting history.",
    pr_faq_title: "Frequently Asked Questions",
    pr_faq_q1: "What are meeting usage minutes?",
    pr_faq_a1:
      "Meeting usage minutes are calculated based on the number of participants and meeting duration. For example, a 1-hour meeting with 10 participants uses 600 meeting usage minutes.",
    pr_faq_q2: "Are paid plans really unlimited?",
    pr_faq_a2:
      "Paid plans include unlimited meeting duration, subject to monthly fair use and platform usage policy.",
    pr_faq_q3: "Can I try Dmeets for free?",
    pr_faq_a3:
      "Yes! The Free plan is available forever, and the Pro and Business plans include a 14-day free trial with no credit card required.",
    pr_faq_q4: "Where are recordings stored?",
    pr_faq_a4:
      "Meeting recordings are stored in Dmeets-controlled storage, with access, retention, and deletion managed by Dmeets.",
    pr_faq_q5: "Do unused recording minutes roll over?",
    pr_faq_a5:
      "No. Recording quota resets monthly and unused recording minutes do not roll over.",
    pr_faq_q6: "Can we purchase extra usage or recording minutes?",
    pr_faq_a6:
      "Yes. Extra meeting usage and recording minutes can be purchased when needed.",
    pr_faq_q7: "How do I cancel my subscription?",
    pr_faq_a7:
      "You can cancel anytime through your account settings. No penalties or hidden fees.",
    pr_cta_title: "Ready to Get Started?",
    pr_cta_subtitle:
      "Start with our free plan or try Pro/Business free for 14 days. No credit card required.",
    pr_cta_start: "Start Free Now",
    pr_cta_contact: "Contact Us",
  },
};
